module.exports = (require("./helpers/browser/import-polyfill")(parcelRequire.resolve("l8pmU"))).then(() => parcelRequire('jT2D4'));